import { doRequest } from '@r1-frontend/do-request/index';
import { makePaymentWithBinding } from '@r1-frontend/api-domru/api-pay/v1/payment/card';
import { IPayByCard } from '@r1-frontend/api-domru/api-pay/v1/payment/dto/IPayByCard';

import { selectCardPaySum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { pushDataLayer } from '~/src/features/payments-abn/helpers/pushDataLayer';
import { updateTransaction } from '~/src/features/payments-abn/store/actions';
import { updateOffer } from '~/src/features/specialOffersContainer/store/actions/thunk';
import { selectOffer } from '~/src/features/specialOffersContainer/store/selectors';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { getClientAll } from '~/src/store/actions/auth/getClientAll';

import { IPaymentResult, setPaymentResult } from '../actionCreators';

interface IPayParams {
    deliveryRequestId: string,
    transaction?: string,
    transactionSum?: string,
}
// платеж с привязанной карты
const bindedCardPayment = (additionalParams?: IPayParams) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();

        const {
            city: { provider: { providerId } },
            payment: { paymentData: { paymentSum, email, isConnectAutoPay }, method, result },
        } = state;
        const popupOffer = selectOffer(state);
        const cardPaymentSum = selectCardPaySum(state);

        const cardId = method?.id;

        const connectAutopay = isConnectAutoPay && !additionalParams?.deliveryRequestId;

        const params: Record<string, unknown> = {
            email: typeof email === 'string' ? email : email.value,
            autopay_act: +connectAutopay,
            payment_value: cardPaymentSum,
            binding_id: cardId,
            payment_source: 1,
            return_url: location.origin + '/payments-response?',
        };

        // Оплата заказа, подставляем delivery_request_id - для привязки оплаты к заказу
        if (additionalParams?.deliveryRequestId) {
            params.delivery_request_id = additionalParams.deliveryRequestId;
        }

        if (cardId) {
            const resp = await doRequest.apiPay<IPayByCard>(
                makePaymentWithBinding(providerId, params),
            );

            pushDataLayer('click payment by old card', resp.isSuccess ? 'success' : 'error');

            let isOpenPopup = true;

            if (resp.isSuccess && additionalParams) {
                const { transaction, transactionSum } = additionalParams;

                if (transaction && transactionSum) {
                    const isTransactionPayed = paymentSum >= Number(transactionSum);

                    dispatch(updateTransaction({
                        id: transaction,
                        payed: isTransactionPayed,
                    }));

                    if (popupOffer && isTransactionPayed) {
                        isOpenPopup = false;
                        dispatch(updateOffer());
                    }
                }
            }

            const respData: IPaymentResult = {
                ...result,
                payStatus: resp.isSuccess ? resp?.payload?.payStatus ?? 0 : 0,
                isOpenPopup,
                isPayCardSuccess: resp.isSuccess,
            };

            dispatch(setPaymentResult(respData));
            dispatch(getClientAll());
        }
    };
};

export default bindedCardPayment;
